import { Certificate } from '@revenuemarket/bank';
import { API } from '~apis/axios/instance';
import { CreateCertificateRequest } from '~models/certificate';
import { ResponseBase } from '~types/response';

export interface PostCertificatesResponse extends ResponseBase {
  data: {
    certificates: Certificate[];
  };
}

interface CompanyIdentifier {
  companyId: string;
}

/**
 * 인증서 등록 및 등록 계좌 조회 API
 * @link https://bank.dev.clobe.ai/swagger-ui/index.html#/Certificate%20API/connectCertificate
 *
 * @param companyId
 * @returns
 */
export default function postCertificates({
  companyId,
  request,
}: CompanyIdentifier & { request: CreateCertificateRequest }) {
  return API.post<PostCertificatesResponse>(`/api/v3/companies/${companyId}/certificates`, {
    data: request,
  });
}
